import { createFileRoute } from '@tanstack/react-router'
import { SystemHealthDashboard } from '../../../features/admin/SystemHealthDashboard'

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/admin/system-health')({
  component: AdminSystemHealthRoute,
})

/* ───── Route Component ───── */

function AdminSystemHealthRoute() {
  return <SystemHealthDashboard />
}
